import { Award, Eye, HeadphonesIcon, Heart, Shield } from "lucide-react";
import React from "react";
import Testimonials from "../db/Testimonials";
import Carousel from "../components/Carousel";
import Footer from "./Footer";

const About = () => {

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative bg-gradient-to-r from-[#F7EDE2] to-[#F5CAC3] py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <div className="max-w-7xl mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-6">
            Who We Are
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto">
            Crafting beautiful spaces with sustainable furniture since 2015
          </p>
        </div>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-serif font-bold text-gray-900 mb-4 mt-4">
            Our Mission & Vision
          </h2>
          <div className="w-24 h-1 bg-[#84A59D] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="bg-white rounded-xl shadow-md p-8 transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
            <div className="w-16 h-16 bg-[#F5CAC3] rounded-full flex items-center justify-center mb-6">
              <Heart className="w-8 h-8 text-[#E07A5F]" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-gray-900 mb-4">
              Our Mission
            </h3>
            <p className="text-gray-600 leading-relaxed">
              To create beautiful, sustainable furniture that transforms houses
              into homes, while respecting our planet and supporting the
              communities we work with. We believe that exceptional design
              should be accessible, ethical, and built to last generations.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-8 transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
            <div className="w-16 h-16 bg-[#F5CAC3] rounded-full flex items-center justify-center mb-6">
              <Eye className="w-8 h-8 text-[#E07A5F]" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-gray-900 mb-4">
              Our Vision
            </h3>
            <p className="text-gray-600 leading-relaxed">
              To lead the furniture industry in combining timeless design,
              environmental stewardship, and social responsibility. We envision
              a world where every home contains pieces that tell a story,
              created with care for both people and planet, inspiring a more
              conscious approach to living.
            </p>
          </div>
        </div>
        <div className="max-w-7xl mx-auto mt-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-serif font-bold text-gray-900 mb-4">
              Meet Our Team
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              The passionate individuals behind Nestora's success
            </p>
            <div className="w-24 h-1 bg-[#84A59D] mx-auto mt-4"></div>
          </div>
        </div>

        <div className="mb-20 ">
          <div className="card w-[350px] h-[400px]  group relative rounded-xl bg-white mx-auto">
            <div className="front flex flex-col h-[400px]">
              <img src="dsff" alt="owner" className="w-[100%] h-[80%] " />
              <div className="fronttext text-center">
                <h1 className="text-xl font-semibold">Sai Abburi</h1>
                <p>Owner</p>
              </div>
            </div>
            <div className="back bg-green-500/10 opacity-0 group-hover:opacity-100 transition-transform-[400s] rounded-xl absolute top-0 h-[100%] flex items-center justify-center">
              <p className="text-lg p-2">
                Sai Abburi founded Nestora with a vision to create sustainable,
                beautiful furniture that lasts generations.
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-serif font-bold text-gray-900 mb-4">
              Why Choose Us
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              What sets Nestora apart from the rest
            </p>
            <div className="w-24 h-1 bg-[#84A59D] mx-auto mt-4"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white rounded-xl shadow-md p-8 text-center transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
              <div className="w-16 h-16 bg-[#F5CAC3] rounded-full flex items-center justify-center mx-auto mb-6">
                <Shield className="w-8 h-8 text-[#E07A5F]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Trust & Reliability
              </h3>
              <p className="text-gray-600">
                With thousands of satisfied customers and a commitment to
                transparency, we've built our reputation on trust and
                reliability in every interaction.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-md p-8 text-center transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
              <div className="w-16 h-16 bg-[#F5CAC3] rounded-full flex items-center justify-center mx-auto mb-6">
                <Award className="w-8 h-8 text-[#E07A5F]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Quality Craftsmanship
              </h3>
              <p className="text-gray-600">
                Each piece is meticulously crafted using premium materials and
                time-honored techniques, ensuring furniture that's not just
                beautiful but built to last.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-md p-8 text-center transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
              <div className="w-16 h-16 bg-[#F5CAC3] rounded-full flex items-center justify-center mx-auto mb-6">
                <HeadphonesIcon className="w-8 h-8 text-[#E07A5F]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Customer Focus
              </h3>
              <p className="text-gray-600">
                From personalized design consultations to white-glove delivery,
                we go above and beyond to ensure an exceptional experience at
                every touchpoint.
              </p>
            </div>
          </div>
        </div>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-serif font-bold text-gray-900 mb-4">
              What Our Customers Say
            </h2>
            <div className="w-24 h-1 bg-[#84A59D] mx-auto"></div>
          </div>
          <div className="mb-5">
            <Carousel slides={Testimonials}/>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default About;
